exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer[data-v-8cd5c9c6]{display:table;width:100%;height:100%}.outer .inner[data-v-8cd5c9c6]{padding:10px;display:table-cell;vertical-align:middle;text-align:center;font-family:Delius,serif;font-size:18px;line-height:2px;padding:0}.outer .inner span[data-v-8cd5c9c6]{position:relative;top:-6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8cd5c9c6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/widgets/WidgetRadio.vue
// module id = 90
// module chunks = 0